import { useContext } from 'react';

import { SearchContext } from '../context';
import { SearchState } from '../types';

export function useSearchContext<T = any, M = any>():
  | SearchState<T, Record<string, any>, M>
  | undefined;
export function useSearchContext(): SearchState | undefined {
  return useContext(SearchContext);
}
